define('v3/Common/Services/Frontend/Notifications.Service',[
	'jquery',
	'lodash',
	'pnotify',
	'pnotify.buttons',
	'pnotify.animate',
	'pnotify.callbacks',
	'pnotify.mobile'
], function ($, _, PNotify) {
	PNotify.styling.snappet = {
		container: 'pnotify-snappet',
		error: 'pnotify-snappet-error',
		error_icon: 'pnotify-snappet-icon-error',
		info: 'pnotify-snappet-info',
		info_icon: 'pnotify-snappet-icon-info',
		notice: 'pnotify-snappet-notice',
		notice_icon: 'pnotify-snappet-icon-notice',
		success: 'pnotify-snappet-success',
		success_icon: 'pnotify-snappet-icon-success',
		closer: 'svg-icon svg-icon-close'
	};

	var defaults = {
		styling: 'snappet',
		title: false,
		text: '',
		icon: false,
		hide: false,
		width: 396,
		animate: {
			animate: true,
			in_class: 'flipIn',
			out_class: 'flipOut'
		},
		after_init: function () {
			$(window).trigger('resize');
		},
		mobile: {
			swipe_dismiss: true,
			styling: false
		},
		buttons: {
			closer: true,
			closer_hover: false
		},
		stack: {
			dir1: 'down',
			dir2: 'left',
			push: 'bottom',
			spacing1: 10,
			spacing2: 30,
			context: $('body'),
			modal: false
		}
	};

	var defaultsInfo = $.extend({}, defaults, { hide: true, delay: 3000, mouse_reset: false });

	var ajaxErrorOpen;
	var getOptions = function (options) {
		if (_.isString(options)) {
			options = {
				text: options
			};
		}

		return options;
	};

	var addTopIndent = function (options) {
		var topIndent = 25;
		var navBar = $('main-menu>.menu')[0];
		if (navBar) {
			topIndent += navBar.clientHeight;
		}
		options.stack.firstpos1 = topIndent;
		return options;
	};

	return {
		show: function (options) {
			options = $.extend({}, defaults, getOptions(options));
			options = addTopIndent(options);
			new PNotify(options); // eslint-disable-line no-new
		},

		info: function (options) {
			options = $.extend({ type: 'notice' }, defaultsInfo, getOptions(options));
			this.show(options);
		},

		error: function (options) {
			options = $.extend({ type: 'error' }, defaults, getOptions(options));
			this.show(options);
		},

		success: function (options) {
			options = $.extend({ type: 'success' }, defaultsInfo, getOptions(options));
			this.show(options);
		},

		ajaxError: function (options) {
			options = $.extend({
				type: 'error',
				after_close: function () {
					ajaxErrorOpen = false;
				}
			}, defaults, getOptions(options || Strings.ErrorOccurred));

			if (!ajaxErrorOpen) {
				ajaxErrorOpen = true;

				this.show(options);
			} else {
				console.warn('There is already an notification showing an AJAX error. Supressing AJAX errors while this notification is open.');
			}
		}
	};
});

